
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {IRouteStop} from '@/model/Route/routeInterfaces';
import {orderStatusColor} from '@/helpers/orderStatusHelper';

/**
 * Ordered list of route stops (order stops + extra stops). Reordering emits the new array through `input`.
 * Desktop reorders with HTML5 drag & drop; touch screens, where native drag & drop is not supported, get
 * up/down buttons instead.
 */
@Component({name: 'RouteStopsEditor'})
export default class RouteStopsEditor extends Vue {
  @Prop({required: true}) protected value!: IRouteStop[];

  protected draggingIndex: number | null = null;
  protected dragOverIndex: number | null = null;

  protected get touch(): boolean {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  protected stopLetter(index: number): string {
    return String.fromCharCode(65 + index);
  }

  protected orderStatusColor(status: string): string {
    return orderStatusColor(status);
  }

  protected moveStop(fromIndex: number, delta: number) {
    const toIndex = fromIndex + delta;
    if (toIndex < 0 || toIndex >= this.value.length) {
      return;
    }
    this.emitMoved(fromIndex, toIndex);
  }

  protected onDragStart(index: number, event: DragEvent) {
    this.draggingIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(index));
    }
  }

  protected onDrop(targetIndex: number) {
    if (this.draggingIndex !== null && this.draggingIndex !== targetIndex) {
      this.emitMoved(this.draggingIndex, targetIndex);
    }
    this.resetDrag();
  }

  protected resetDrag() {
    this.draggingIndex = null;
    this.dragOverIndex = null;
  }

  private emitMoved(fromIndex: number, toIndex: number) {
    const stops = this.value.slice();
    const moved = stops.splice(fromIndex, 1)[0];
    stops.splice(toIndex, 0, moved);
    this.$emit('input', stops);
  }
}
